<template>
  <div class="appBody bg-grey-light min-vh-100  rec-course-list position-relative"
       v-if="project">
    <div v-if="courseList && courseList.length>0">
      <div class="course-item d-flex align-items-center rounded bg-white px-3 pt-3 pb-4 mb-20 position-relative"
           ref="checkboxGroup" v-for="item in courseList" :key="item.id">
        <img v-if="item.mustSelected" class="must-icon position-absolute top-0 right-0"
             src="/static/img/index/must_learn.png" alt="">
        <input class="box cursor-pointer" v-if="item"
               :class="{'isChecked': item.isAdd && !item.mustSelected,'disableImg': item.mustSelected, 'bg-grey':item.haveCourse}"
               :disabled="item.mustSelected||item.haveCourse"
               type="checkbox" @change="select(item, $event)"
               :name="item.courseId" v-model="item.isAdd" :value="item.isAdd">
        <div class="w-100 ml-12" @click="goAdvPage(item.courseId)">
          <p class="mb-12 font-14 van-multi-ellipsis--l2 line-20 text-justify">
            {{ item.course.title }}
          </p>
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="color-66 font-10">
              {{
                (item.course.statInfo &&
                  item.course.statInfo.mustLearnSessionCount) ? item.course.statInfo.mustLearnSessionCount : 0
              }}小节
            </div>
            <div  class="font-11 color-88" v-if="item.haveCourse">
              【已拥有，本项目无法选择】
            </div>
            <div v-else class="font-11 color-88">
              <span v-if="project.assessable && project.standardScore > 0">积分：{{ item.score }} </span>
              <span>学时:{{ item.credit }}</span>
              <span :class="{'text-decoration-through': item.haveCourse}" class="text-primary font-13"
                    v-if="item.free || item.price === 0.0">
              免费
            </span>
              <span :class="{'text-decoration-through': item.haveCourse}" class="color-88 font-11" v-else>
              ¥ {{ item.price|getMoney }}
            </span>

            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed bottom-fixed bg-grey-light">
        <div class="d-flex justify-content-between h-100 w-100 align-items-center">
          <van-checkbox class="selectAll h-100" @click="checkAll" v-model="checked">全选</van-checkbox>
          <div class="d-flex align-items-baseline select-right ml-auto  h-100">
            <span class="font-14 color-66 mr-1">学时:{{ allCredit }}</span>
            <span class="font-14 color-66 mr-1" v-if="allScore>0">积分:{{ allScore }}</span>
            <span class="font-22 text-primary mr-1">¥{{ allCost|getMoney }}</span>
            <div @click="goResultPage" class="bg-primary cursor-pointer text-white font-16 btnText h-100">
              <!--             <span v-if="allCost>0">{{'购买('+selectedList.length+')'}}</span>-->
              <span>{{ '选课(' + selectedList.length + ')' }}</span>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="text-center pt-3">
      <img width="25%" :src="noMoreImage">
    </div>
  </div>
</template>

<script>

import NoData from "@/components/noData";
import Vue from 'vue';
import {Checkbox, CheckboxGroup, Dialog} from 'vant';
import {mapState} from "vuex";

Vue.use(Dialog);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
export default {
  name: "recommendCourse",
  components: {
    NoData,
  },
  data() {
    return {
      courseList: [],
      checked: false,
      showShare: false,
      shareObj: {},
      // proLearningStartTime: 0,
      // proLearningEndTime: 0,
      allCost: 0,
      allCredit: 0,
      allScore: 0,
      projectTimeObj: {},
      projectObj: {},
      selectedList: [],
      courseIds: [],
      selectedObj: {}
    }
  },
  props: [
    'coursesList',
    'proTimeObj',
    'project'
  ],
  created() {
    this.courseList = this.coursesList;
    this.projectTimeObj = this.proTimeObj;
    this.projectObj = this.project;
    this.getCourseList();
    // this.proLearningStartTime = this.projectTimeObj.proLearningStartTime;
    // this.proLearningEndTime = this.projectTimeObj.proLearningEndTime;
    // if (this.courseList && this.courseList.length > 0) {
    //   this.getNewTag();
    // }
  },
  computed: {
    ...mapState({
      uploadresUrl: state => state.uploadresUrl,
      noMoreImage: state => state.noMoreImage,
    })
  },
  methods: {
    goAdvPage(id) {
      this.$router.push('/course/' + id)
    },
    goResultPage() {
      // 项目时间内才可以选课
      if (this.selectedList && this.selectedList.length > 0) {
        this.selectedObj.courseList = this.selectedList;
        this.selectedObj.allCost = this.allCost;
        this.selectedObj.allCredit = this.allCredit;
        this.selectedObj.allScore = this.allScore;
        this.selectedObj.project = this.projectObj;
        localStorage.setItem('selectedObj', JSON.stringify(this.selectedObj));
        this.$router.push('/order/result');
      } else {
        Dialog.alert({
          title: '提示',
          message: '您尚未选择课程',
        }).then(() => {

        });
      }

    },
    checkAll() {
      if (this.checked) {
        this.selectedList = this.courseList.filter(v => (!v.haveCourse));
        this.selectedList.map(v => v.isAdd = true);
      } else {
        this.selectedList = this.courseList.filter(v => (v.mustSelected));
        let noSelectList = this.courseList.filter(v => !(v.mustSelected));
        noSelectList.map(v => v.isAdd = false);
      }
      this.computePrice();
    },
    select(item, event) {
      let status = event.target.checked;
      item.isAdd = status;
      if (!status) {
        this.selectedList.splice(this.selectedList.indexOf(item), 1);
        this.checked = false;
      } else {
        const courseListExpertHasCourse = this.courseList.filter(v => (!v.haveCourse));
        this.selectedList.push(item);
        if (this.selectedList.length === courseListExpertHasCourse.length) {
          this.checked = true;
        }
      }
      this.computePrice();
    },
    computePrice() {
      this.courseIds = [];
      if (this.selectedList && this.selectedList.length > 0) {
        for (let j of this.selectedList) {
          if (j.courseId) {
            this.courseIds.push(j.courseId)
          }
        }
        this.$store.dispatch('getProjectCourseListPrice', {
          id: this.projectObj.id,
          courseIds: this.courseIds.join()
        }).then((res) => {
          this.allCost = res.price;
          this.allCredit = res.credit;
          if (!this.projectObj.assessable || this.projectObj.standardScore <= 0) {
            this.allScore = -1;
          } else {
            this.allScore = res.score;
          }

        })
      } else {
        this.allCost = 0;
        this.allCredit = 0;
        this.allScore = 0;
      }
    },
    getCourseList() {
      if (this.courseList && this.courseList.length > 0) {
        for (let v of this.courseList) {
          v.isAdd = false;
          if (v.mustSelected) {
            v.isAdd = true;
            this.selectedList.push(v);
          }
        }
        this.computePrice();
      }
    },
    // goToPage(item) {
    //   let nowTime = new Date().getTime();
    //   if (nowTime >= this.proLearningStartTime && nowTime <= this.proLearningEndTime
    //     && (item.learningTimeLimit || (nowTime >= item.learningStartTime && nowTime <= item.learningEndTime))) {
    //     this.$router.push({name: 'indexCourse', params: {id: item.courseId}, query: {proId: item.projectId}});
    //   } else {
    //     this.$toast('该课程暂未开放学习！')
    //   }
    // },

    // getNewTag() {
    //   for (let obj of this.courseList) {
    //     //处理tag的长度,大于22个字，显示2个。否则显示3个
    //     if (obj.course && obj.course.tag && obj.course.tag.length > 0) {
    //       let tagArr = [];
    //       let len = 0;
    //       tagArr = obj.course.tag.slice(0, 3);
    //       for (let t of tagArr) {
    //         len += t.length;
    //         if (len >= 22) {
    //           tagArr.slice(0, 2);
    //         } else {
    //           tagArr.slice(0)
    //         }
    //       }
    //       obj.tags = tagArr;
    //     } else {
    //       obj.tags = [];
    //     }
    //   }
    // },


  }

}
</script>

<style scoped lang="scss">
$browser-default-font-size: 16px !default;
@function pxTorem($px) {
  @return $px / $browser-default-font-size * 1rem;
}

.rec-course-list {
  .bottom-fixed {
    border-top: 1px solid #e3e3e3a6;
  }

  .box {
    outline: none;
    width: pxTorem(20px);
    height: pxTorem(19px);
    background-color: #ffffff;
    border: 1px solid #cccccc;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    margin: 0;
    padding: 0;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -webkit-user-select: none;
    user-select: none;
  }

  .isChecked {
    background: url("/static/img/pro/checked.png") no-repeat;
    background-size: 100% 100%;
    border: 0;
  }

  .disableImg {
    background: url("/static/img/pro/disable.png") no-repeat;
    background-size: 100% 100%;
    border: 0;
  }

  .selectAll {
    padding-left: pxTorem(10px);
    width: pxTorem(80px);
  }

  .btnText {
    width: pxTorem(98px);
    display: flex;
    justify-content: center;
    align-items: center;
  }

}
.bg-grey {
  background-color: #eeeeee !important;
}
</style>
